import { render, staticRenderFns } from "./DialogContentAutoRenewalInfoMobile.vue?vue&type=template&id=08f9fae2&scoped=true&"
import script from "./DialogContentAutoRenewalInfoMobile.vue?vue&type=script&lang=js&"
export * from "./DialogContentAutoRenewalInfoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9fae2",
  null
  
)

export default component.exports